// Fixed viewpoints for checking the stadium (`?view=start|finish|overview|stand|lake|podium|lane`).
// A development aid only: the director owns the real cameras. `?viewx=<m>` moves the
// travelling views (stand, lake, lane) along the course.
import type { PerspectiveCamera } from 'three';
import { TRACK_LENGTH } from '../../data/track';
import { PODIUM } from './layout';

type View = { pos: [number, number, number]; look: [number, number, number]; fov?: number };

export function environmentView(name: string, x = 300): View | null {
  const views: Record<string, View> = {
    start: { pos: [13, 1.7, -5.5], look: [-1, 1.1, 0.8] },
    finish: { pos: [TRACK_LENGTH - 22, 2.6, -7.5], look: [TRACK_LENGTH, 3, 1.5] },
    overview: { pos: [x - 90, 55, -95], look: [x + 20, 0, 15], fov: 45 },
    stand: { pos: [x, 2.2, 8], look: [x + 18, 4.5, -16] },
    lake: { pos: [x, 4.2, -14], look: [x + 40, 1.5, 60] },
    podium: { pos: [PODIUM.x - 2, 2.2, PODIUM.z - 9], look: [PODIUM.x, 1.6, PODIUM.z + 1] },
    lane: { pos: [x - 9, 0.55, -2.2], look: [x + 30, 0.6, 0.5] },
  };
  return views[name] ?? null;
}

/** Applies `?view=` if present. Returns true when the camera was placed. */
export function applyDebugView(camera: PerspectiveCamera): boolean {
  const q = new URLSearchParams(location.search);
  const v = environmentView(q.get('view') ?? '', Number(q.get('viewx') ?? 300));
  if (!v) return false;
  camera.position.set(...v.pos);
  camera.lookAt(...v.look);
  if (v.fov && camera.fov !== v.fov) { camera.fov = v.fov; camera.updateProjectionMatrix(); }
  return true;
}
